import { render, staticRenderFns } from "./notify_transfer_agent.vue?vue&type=template&id=e96147a2"
import script from "./notify_transfer_agent.vue?vue&type=script&lang=js"
export * from "./notify_transfer_agent.vue?vue&type=script&lang=js"
import style0 from "./notify_transfer_agent.vue?vue&type=style&index=0&id=e96147a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports